module.exports = __webpack_public_path__ + "static/media/amougeref.024d0e1c.png";